export class  M3OtClasificaciones{
    public ID:number;
    public IdProducto:string;
    public Valor:number;
    public Nombre:string;
    public Cantidad:number;
    public Orden:number;//Variable de ordenamiento en el front
}